if (!customElements.get('wishlist-button')) {
	class WishlistButton extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			document.addEventListener('DOMContentLoaded', () => {
				this.productHandle = this.getAttribute('data-product-handle')
				this.productVariantId = this.getAttribute('data-product-variant-id')
				this.addEventListener('click', this.handleClick)
				this.isProductInWishlist()
			})
		}

		disconnectedCallback() {
			this.removeEventListener('click', this.handleClick)
		}

		handleClick() {
			if (this.productIsInWishlist) {
				window.Maestrooo.wishlist.removeProduct(this.productHandle, this.productVariantId)
			} else {
				window.Maestrooo.wishlist.addProduct(this.productHandle, this.productVariantId)
			}
		}

		isProductInWishlist() {
			window.Maestrooo.wishlist.containsProduct(this.productHandle).then(productIsInWishlist => {
				alert(productIsInWishlist)
				return productIsInWishlist
			})
		}
	}

	customElements.define('wishlist-button', WishlistButton)
}
